import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export function getEntity(entityID) {
  return api.get(`/v3/entities/${entityID}/fields`)
}

export function getEntityFilterFields(entityID) {
  return api.get(`/v3/entities/${entityID}/filters?limit=50&web=true`)
}

export function getEntitySearchFilterFields(entityID, search) {
  search = encodeURIComponent(search)
  return api.get(`/v3/entities/${entityID}/filters?limit=50&query=${search}&web=true`)
}

export function getEntityAutoUpdateFields(entityID) {
  return api.get(`/v3/entities/${entityID}/fields?auto_update_fields=true`)
}

export function getEntityAutoUpdateFieldsValues(entityID, fieldID) {
  return api.get(
    `/v3/entities/${entityID}/field_values?auto_update_fields=true&id=${entityID}&field_ids=[${fieldID}]`
  )
}

export function getSearchUsers(entityID, seatchTerm) {
  return api.get(`/v3/entities/${entityID}/search_users?search_term=${seatchTerm}`)
}

export function getEntityUserUpdateFields(entityID) {
  return api.get(`/v3/entities/${entityID}/fields?user_update_fields=true`)
}

export function getEntities() {
  return api.get(`/v3/entities/user_entities`)
}
export function getEntityChild(params) {
  return api.post(`/v3/entities/child_fields`, {
    child_fields: params,
  })
}

export function getStepEntities({field_ids, field_type, object_id}) {
  return api.get(`/v3/entities/step_entities`, {
    params: {field_ids, object_id, field_type},
  })
}

export function getReservationEntityItems(
  entity_id,
  {
    page = 1,
    limit = 50,
    query = '',
    filters = {},
    start_date = '',
    end_date = '',
    object_ids = [],
    reservation_uid = '',
    formattedDateFrom = '',
    formattedDateTo = '',
  }
) {
  return api.post(`/v3/entities/${entity_id}/reservation_entity_items`, {
    page: page,
    limit: limit,
    query: query,
    filters: filters,
    start_date:
      Object.keys(filters).length === 0 && start_date === ''
        ? formattedDateFrom
        : Object.keys(filters).length !== 0 && start_date === ''
        ? formattedDateFrom
        : start_date,
    end_date:
      Object.keys(filters).length === 0 && end_date === ''
        ? formattedDateTo
        : Object.keys(filters).length !== 0 && end_date === ''
        ? formattedDateTo
        : end_date,
    object_ids: object_ids,
    reservation_uid: reservation_uid,
  })
}

export function getFilterFieldValues(fieldId, search = '', params = {limit: 50, page: 1}) {
  return api.get(`/v3/field/${fieldId}/object_values`, {
    params: {
      ...params,
      query: search,
    },
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
}

export function searchEntityFieldTypes(entity_id, params) {
  return api.post(`/v3/entities/${entity_id}/field_types`, params)
}

export function getEntityStatuses(entityID, params) {
  return api.get(`/v3/groups/${entityID}/statuses?field_id=${params.id}`)
}

// Calendar Right sidebar API
export function getCalendarSearchApi(entity_id, params) {
  return api.post(`/v3/groups/${entity_id}/reservation_calender_objects`, params)
}
